/*
 * @providesModule GameOperationsTutorial
 *
 */

import React, {useRef, useState} from 'react';
import {View, StyleSheet, findNodeHandle, SafeAreaView} from 'react-native';
import SpotlightMaskedView from 'SpotlightMaskedView';
import {stylesFn} from './GameOperationsTutorial.styles';
import {FTUETrainerText} from '@skillz/ui';
import {
  useArrowOffsetsByStepMap,
  useGameOperationsTutorialTrainer,
} from './GameOperationsTutorialController';

type GameOperationsTutorialProps = {
  onCompleted?: () => void;
};

export default function GameOperationsTutorial({onCompleted}: GameOperationsTutorialProps) {
  const styles = stylesFn();

  const {trainerProps, isCompleted, currentStep, advanceStep} = useGameOperationsTutorialTrainer();

  /** Spotlight definitions */
  const [spotlightNode, setSpotlightNode] = useState<number>(0);
  const gameOperationsSpotlightContainerRef = useRef<View | null>(null);

  // defines arrow horizontal position for the current step, to be used in the spotlight
  const arrowOffsetsByStepMap = useArrowOffsetsByStepMap();
  const arrowOffset = arrowOffsetsByStepMap[currentStep];

  // slightly expands spotlight area on top & bottom to give some padding in case of icons animations
  const spotLightInsets = {top: -10, bottom: -10, right: 0, left: 0};

  function _setSpotlightRef() {
    const spotlightNode = !!gameOperationsSpotlightContainerRef.current
      ? findNodeHandle(gameOperationsSpotlightContainerRef.current)
      : null;
    spotlightNode && setSpotlightNode(spotlightNode);
  }

  if (isCompleted) {
    onCompleted?.();
    console.debug('GameOperationsTutorial: Skip render - tutorial is completed');
    return null;
  }

  return (
    <SafeAreaView style={[StyleSheet.absoluteFill, {elevation: 18}]}>
      <View
        style={styles.gameOperationsSpotlightContainer}
        ref={gameOperationsSpotlightContainerRef}
        onLayout={_setSpotlightRef}
      />

      {spotlightNode && !trainerProps?.overlayVisible ? (
        <SpotlightMaskedView
          refCallback={(ref: any) => {
            // This is needed by SpotlightMaskedView to work properly
          }}
          maskRef={spotlightNode}
          insets={spotLightInsets}
          arrowDirection={'bottom'}
          arrowOffset={arrowOffset}
          hideArrow={false}
          acceptTouches={true}
          showSpotlight={true}
          showAnimation={false}
          animationOpacity={80}
          animationInterval={1}
          animationDuration={1000}
        />
      ) : null}

      {!!trainerProps && <FTUETrainerText {...trainerProps} onPress={advanceStep} />}
    </SafeAreaView>
  );
}
